import { useState } from "react";

const STORAGE_KEY = "adultnet:age-verified";

export default function AgeGate() {
  const [status, setStatus] = useState<"pending" | "adult" | "minor">(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === "1" ? "adult" : "pending";
    } catch {
      return "pending";
    }
  });

  const confirmAdult = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // ignore storage failures
    }
    setStatus("adult");
  };

  if (status === "adult") {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-background-950/90 px-4 backdrop-blur-md">
      <div className="w-full max-w-md animate-fade-up rounded-xl border border-background-300 bg-background-100 p-7">
        <div className="mb-6 flex items-center gap-2">
          <span className="font-heading text-xl font-semibold text-foreground-950">
            成人<span className="text-primary-400">网</span>
          </span>
          <span className="rounded-sm border border-accent-500/70 px-1.5 py-px text-[10px] text-accent-500">
            18+
          </span>
        </div>

        {status === "minor" ? (
          <div>
            <h2 className="text-lg font-medium text-foreground-950">抱歉，暂时无法继续访问</h2>
            <p className="mt-2.5 text-sm leading-relaxed text-foreground-500">
              本站内容仅面向已满 18 周岁的成年观众。感谢你的理解，请在有监护的环境下浏览其他适龄内容。
            </p>
            <a
              href="https://www.google.com"
              rel="noopener noreferrer"
              target="_blank"
              className="mt-6 flex w-full items-center justify-center gap-2 rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-500"
            >
              <i className="ri-arrow-left-line"></i>
              离开本站
            </a>
            <button
              type="button"
              onClick={() => setStatus("pending")}
              className="mt-3 w-full text-center text-xs text-foreground-500 underline-offset-4 hover:underline cursor-pointer"
            >
              返回确认
            </button>
          </div>
        ) : (
          <div>
            <h2 className="text-lg font-medium text-foreground-950">适龄提示</h2>
            <p className="mt-2.5 text-sm leading-relaxed text-foreground-500">
              本站包含成人向的影像与文字内容，仅限 18 岁以上人士浏览。
              所有内容均为演示展示，站内不提供真实播放，也不会存储你的个人信息。
            </p>
            <div className="mt-5 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-[11px] leading-relaxed text-foreground-500">
              继续访问即表示你已确认自己已满法定年龄，并自愿浏览相关内容。
            </div>
            <button
              type="button"
              onClick={confirmAdult}
              className="mt-6 flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              我已满 18 岁，进入本站
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              type="button"
              onClick={() => setStatus("minor")}
              className="mt-3 w-full rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-600 transition-colors hover:border-background-400 whitespace-nowrap cursor-pointer"
            >
              我未满 18 岁
            </button>
          </div>
        )}
      </div>
    </div>
  );
}